import AttendingPhysician from './AttendingPhysician';

export default AttendingPhysician;
